import { useState, useEffect } from 'react';

export default function useDebounce(value, delay = 500, trim = false) {

    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {

        const timer = setTimeout(() => {
            const finalValue = trim && typeof value === 'string' ? value.trim() : value;
            setDebouncedValue(finalValue);
        }, delay);

        return () => clearTimeout(timer);

    }, [value, delay, trim]);

    return debouncedValue;
}